import { useEffect } from "react";
import { X, Minus, ArrowSquareOut } from "@phosphor-icons/react";

// Visor de imagen a pantalla completa con cerrar (X) y minimizar (–).
// state: null | { url, name, minimized }
export function Lightbox({ item, onClose, onMinimize }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  if (!item) return null;

  if (item.minimized) {
    return (
      <button onClick={() => onMinimize(false)} data-testid="lightbox-restore"
        className="fixed bottom-4 right-4 z-[70] w-16 h-16 rounded-sm overflow-hidden border-2 border-primary shadow-xl bg-black">
        <img src={item.url} alt="" className="w-full h-full object-cover" />
      </button>
    );
  }

  return (
    <div className="fixed inset-0 z-[70] bg-black/85 flex flex-col" data-testid="lightbox" onClick={onClose}>
      <div className="flex items-center justify-end gap-2 p-3" onClick={(e) => e.stopPropagation()}>
        <a href={item.url} target="_blank" rel="noreferrer" title="Abrir en pestaña / descargar" data-testid="lightbox-open"
          className="w-10 h-10 flex items-center justify-center rounded-sm bg-white/10 text-white hover:bg-white/20 transition-colors"><ArrowSquareOut size={20} weight="bold" /></a>
        <button onClick={() => onMinimize(true)} title="Minimizar" data-testid="lightbox-minimize"
          className="w-10 h-10 flex items-center justify-center rounded-sm bg-white/10 text-white hover:bg-white/20 transition-colors"><Minus size={22} weight="bold" /></button>
        <button onClick={onClose} title="Cerrar" data-testid="lightbox-close"
          className="w-10 h-10 flex items-center justify-center rounded-sm bg-white/10 text-white hover:bg-white/20 transition-colors"><X size={22} weight="bold" /></button>
      </div>
      <div className="flex-1 flex items-center justify-center p-4 overflow-auto" onClick={(e) => e.stopPropagation()}>
        <img src={item.url} alt={item.name || "foto"} className="max-w-full max-h-full object-contain" />
      </div>
      {item.name && <div className="text-center text-white/70 text-sm pb-4 px-4 truncate" onClick={(e) => e.stopPropagation()}>{item.name}</div>}
    </div>
  );
}
